<h3>{{ title }}</h3>
<div class='content-wrapper'>
    @if(!isLoading) {
    @switch (priorityTask) {
    @case('DISC_MED') {
    <div class="alert alert-primary disclosure-warning group" role="alert">
        <div class="disc-img">
            <i class="fa fa-medkit"></i>
        </div>
        <div class="disc-txt">Having answered &ldquo;Yes&rdquo; to one or more medical questions, we need you to
            <a routerLink="/disclosure" class="white_link">provide us with some more details</a>.
        </div>
    </div>
    }
    @case('DISC_CRIM') {
    <div></div>
    }
    }
    @if(showSubmitApplicationButton) {
    <div class="sub alert alert-primary">
        <h2 class="white">One last thing</h2>
        <p class="center">You are now ready to <a class="white-link" href="/payments/returner">make your payment</a>
            and submit
            your application to the office!</p>
    </div>
    }
    @if(allComplete) {
    <div class="sub alert alert-info">
        <h2>Congratulations</h2>
        <p class="center">You have completed your application &mdash; for your next steps, please visit your <a
                href="/home">home
                page</a>!</p>
    </div>
    }
    <div class="link-wrapper">
        <div class="application-links">
            @for(t of tasks; track t.taskId) {
            <div class="link">
                <button class="task-item" [ngClass]="t.class" (click)="clickTask(t)">
                    <div class="task-title">
                        <div class="heading">{{t.name}}</div>
                    </div>
                </button>
            </div>
            }
        </div>
    </div>
    <div class="summary-wrapper">
        <button class="view-summary review" (click)="goToSummary()">
            <span class="bt"><img src="/img/task/Review Application.png"> Review Application</span>
        </button>
        <button class="view-summary uploads" (click)="goToUploads()">
            <span class="bt"><img src="/img/task/Enhance Application Star.png"> Enhance Application</span>
        </button>
    </div>
    } @else {
    <app-cf-loader>
        <p>Loading summary page...</p>
    </app-cf-loader>
    }

</div>